<template>
    <path d="M14.166 4.00004H17.4993C17.7204 4.00004 17.9323 4.08784 18.0886 4.24412C18.2449 4.4004 18.3327 4.61236 18.3327 4.83337V18.1667C18.3327 18.3877 18.2449 18.5997 18.0886 18.756C17.9323 18.9122 17.7204 19 17.4993 19H2.49935C2.27834 19 2.06637 18.9122 1.91009 18.756C1.75381 18.5997 1.66602 18.3877 1.66602 18.1667V4.83337C1.66602 4.61236 1.75381 4.4004 1.91009 4.24412C2.06637 4.08784 2.27834 4.00004 2.49935 4.00004H5.83268V2.33337H7.49935V4.00004H12.4993V2.33337H14.166V4.00004ZM12.4993 5.66671H7.49935V7.33337H5.83268V5.66671H3.33268V9.00004H16.666V5.66671H14.166V7.33337H12.4993V5.66671ZM16.666 10.6667H3.33268V17.3334H16.666V10.6667Z"
          fill="#B6C3D1"></path>
</template>

<script>
    export default {
        name: 'icon-calendar'
    }
</script>